// Data Contracts
import { PersonName } from '@data-contracts';

/**
 * Formats a PersonName into a display string, mirroring the `personName` pipe
 * (fullName, then "First Last", then whichever single name is present). Returns
 * an empty string when nothing is available (the pipe renders null as empty).
 *
 * Single shared helper for the judge-review mappers (detail / studio / confirm)
 * so the pipe's formatting rules live in exactly one place.
 */
export function personDisplayName(name: PersonName | null | undefined): string {
  if (!name) {
    return '';
  }
  if (name.fullName) {
    return name.fullName;
  }
  if (name.firstName && name.lastName) {
    return `${name.firstName} ${name.lastName}`;
  }
  if (name.firstName) {
    return name.firstName;
  }
  if (name.lastName) {
    return name.lastName;
  }
  return '';
}
